<template>
  <div class="root-container">
    <!--数字概览-->
    <el-row class="box-header">
      <el-col class="title-text-container" v-for="(title,index) in boxTitles" :span="24/boxTitles.length">
        <i class="el-icon-setting" v-if="index==2" @click="showChangeActiveDaysDialog = true"
           style="margin-right: 5px;"/>
        <div class="title-text">{{title.replace('{n}',activeDays)}}</div>
      </el-col>
    </el-row>
    <el-row class="box-main">
      <el-col class="value-text-container" v-for="value in boxValues" :span="24/boxValues.length">
        <div v-loading="loading" element-loading-spinner="el-icon-loading" class="value-text">{{value}}</div>
      </el-col>
    </el-row>
    <!--修改统计天数-->
    <el-dialog title="修改统计天数" :visible.sync="showChangeActiveDaysDialog" width="30%">
      <span>前<el-input-number size="mini" v-model="activeDays" :min="1" :max="365"/>日活跃设备数</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="showChangeActiveDaysDialog = false">取 消</el-button>
        <el-button type="primary" size="mini" @click="changeActiveDays">确 定</el-button>
      </span>
    </el-dialog>
    <!--图表-->
    <el-row class="box-header" style="margin-top: 30px">
      <el-col class="chart-title-text-container" :span="12">
        <div class="chart-title-text">每日活跃设备趋势</div>
      </el-col>
      <el-col class="chart-subtitle-text-container" :span="12">
        <div class="chart-subtitle-text">{{((period && period.length==0) ||
          !period)?'前30日':`从${period[0]}至${period[1]}`}}
        </div>

        <el-date-picker
          v-model="period"
          type="daterange"
          range-separator="至"
          size="mini"
          :editable="false"
          :clearable="true"
          format="yyyy/M/d"
          value-format="yyyy/M/d"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="changePeriod"
          :picker-options="pickerOptions"
          style="width:220px;margin-left: 10px;">
        </el-date-picker>

      </el-col>
    </el-row>
    <el-row class="box-main" style="height: 400px">
      <div v-loading="loading" element-loading-spinner="el-icon-loading" class="box-chart" ref="chart_ref"/>
    </el-row>
    <!--列表-->
    <el-row class="box-header" style="margin-top: 30px">
      <el-col class="chart-title-text-container" :span="12">
        <div class="chart-title-text">活跃设备明细</div>
      </el-col>
      <el-col class="chart-subtitle-text-container" :span="12">
        <div class="chart-subtitle-text">{{((period && period.length==0) ||
          !period)?'前30日':`从${period[0]}至${period[1]}`}}
        </div>
      </el-col>
    </el-row>
    <el-row class="box-main" style="height: 600px;">
      <el-table :data="detail" stripe max-height="600" v-loading="loading" element-loading-spinner="el-icon-loading">
        <el-table-column label="#" width="50" align="center">
          <template slot-scope="scope">
            {{scope.$index+1}}
          </template>
        </el-table-column>
        <el-table-column prop="day_date" label="日期" align="center"/>
        <el-table-column prop="daily_living" label="活跃设备数" align="center"/>
        <el-table-column label="活跃率" align="center">
          <template slot-scope="scope">
            {{parseFloat(scope.row.daily_living/total*100).toFixed(1)}}%
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small"
                       @click="gotoOneDayDetail(scope.row,scope.$index,scope.column)">查看明细
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!--明细-->
    <el-dialog :title="oneDayDetailTitle" :visible.sync="oneDayDetailVisiable" :fullscreen="false"
               :before-close="beforeClose">
      <el-table :data="oneDayDetail">
        <el-table-column label="#" width="50" align="center">
          <template slot-scope="scope">
            {{scope.$index+1}}
          </template>
        </el-table-column>
        <el-table-column label="设备编号" align="center">
          <template slot-scope="scope">
            {{scope.row}}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
  import echarts from 'echarts'
  import {GetActiveDeviceInfo} from "../api/api";

  export default {
    data() {
      return {
        token: '',
        loading: false,
        boxTitles: ['昨日活跃设备数', '昨日活跃率', '前{n}日活跃设备数', '前{n}日活跃率'],
        boxValues: [],
        detail: [],
        xdata: [],
        ydata: [],
        total: -1,
        oneDayDetail: [],
        oneDayDetailTitle: '1970-01-01活跃设备明细',
        oneDayDetailVisiable: false,
        period: [],
        pickerOptions: {
          disabledDate(time) {
            // 最晚到昨天
            let now = new Date()
            let todayZero = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0)
            return time.getTime() >= todayZero.getTime();
          },
          shortcuts: [{
            text: '最近7天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近30天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近90天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        showChangeActiveDaysDialog: false,
        activeDays: 7,
        mChart: null,
        mOption: null,
      }
    },
    methods: {
      query() {
        this.loading = true

        var that = this
        var params = {
          token: this.token,
          days: this.activeDays
        }
        if (this.period.length > 0) {
          params['start_at'] = this.period[0]
          params['end_at'] = this.period[1]
        }
        console.log('123123', params)
        GetActiveDeviceInfo(params).then(res => {
          console.log('1213', res);
          that.total = res.data.summary.total;
          that.boxValues[0] = res.data.summary.yesterday;                                                         //昨日活跃设备数
          that.boxValues[1] = parseFloat(res.data.summary.yesterday / that.total * 100).toFixed(1) + '%';   //昨日活跃率
          that.boxValues[2] = res.data.summary.nearlyDays;                                                       //前n日活跃设备数
          that.boxValues[3] = parseFloat(res.data.summary.nearlyDays / that.total * 100).toFixed(1) + '%'; //前n日活跃率
          that.detail = res.data.detail;

          that.xdata.splice(0, that.xdata.length)
          that.ydata.splice(0, that.ydata.length)
          for (var index in that.detail) {
            that.xdata.push(that.detail[that.detail.length - 1 - index].day_date);
            that.ydata.push(that.detail[that.detail.length - 1 - index].daily_living);
          }

          console.log('xdata', that.xdata);
          console.log('ydata', that.ydata);
          console.log('detail', that.detail);

          this.mChart.setOption(this.mOption);

          this.loading = false
        }).catch(err => {
          this.loading = false
        });
      },
      gotoOneDayDetail(row, index, column) {
        this.oneDayDetail = row.devices;
        this.oneDayDetailTitle = row.day_date + '活跃设备明细';
        this.oneDayDetailVisiable = true;
      },
      beforeClose() {
        this.oneDayDetailVisiable = false;
      },
      changePeriod(value) {
        console.log('changePeriod', value)
        this.$nextTick(() => {
          if (!value) {
            this.initPeriod()
          }
          this.query()
        })
      },
      initPeriod() {
        var end = new Date();
        var start = new Date();
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        this.period = [start.toLocaleDateString(), end.toLocaleDateString()]
      },
      changeActiveDays() {
        console.log('changeActiveDays', this.activeDays)
        this.showChangeActiveDaysDialog = false
        // 请求接口
        this.query()
      }
    },
    created() {
      this.token = sessionStorage.getItem("BBRtoken");
      // 初始化默认时间段
      this.initPeriod()
    },
    mounted() {
      var that = this;
      // 初始化图表
      this.mChart = echarts.init(this.$refs.chart_ref);
      this.mOption = {
        color: ['rgb(126,182,234)'],
        tooltip: {
          trigger: 'axis',
          formatter: '[{b}]<br/>- 活跃{c}台'
        },
        grid: {
          top: '10%',
          left: '3%',
          right: '3%',
          bottom: '10%',
          containLabel: true
        },
        // legend: {
        //     // data: ['12'],
        //     // left: 'auto',
        //     // type: 'plain',
        //     show: true
        // },
        xAxis: {
          data: that.xdata,
          axisLine: {
            lineStyle: {
              color: '#d2e2e2'
            }
          },
          axisLabel: {
            color: '#8492A6',
            fontWeight: 'bold'
          }
        },
        yAxis: {
          splitLine: {
            show: true,
            lineStyle: {
              color: ['#e2e2e2'],
              type: 'dotted'
            }
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#8492A6',
            fontWeight: 'bold',
            formatter: '{value}台'
          }
        },
        series: {
          name: '活跃设备数',
          type: 'line',
          data: that.ydata,
        }
      };
      // 请求数据
      this.query()
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// AnalyzeActiveDeviceManagement.vue?650511e4